<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M4.533 16.065c0-6.95 5.03-11.53 11.264-11.53 4.414 0 7.996 2 9.805 5.174L22.48 8.92a.932.932 0 00-.448 1.808l4.92 1.242a.935.935 0 001.205-1.015l1.148-4.632a.932.932 0 00-.672-1.13.923.923 0 00-1.12.678l-.595 2.405c-2.252-3.519-6.354-5.611-11.122-5.611-7.24 0-13.13 5.392-13.13 13.399a.934.934 0 101.866 0zm24.801-.131a.934.934 0 10-1.866 0c0 6.95-5.03 11.53-11.265 11.53-4.413 0-7.995-2-9.804-5.174l3.12.788a.922.922 0 001.12-.678.932.932 0 00-.671-1.13l-4.92-1.242a.935.935 0 00-1.205 1.015l-1.148 4.632a.932.932 0 00.671 1.13.922.922 0 001.12-.678l.595-2.406c2.253 3.52 6.355 5.612 11.122 5.612 7.24 0 13.13-5.392 13.13-13.399z"/></svg>
</template>

<script>
export default {
  name: 'arrowsCycleCheckOutline'
}
</script>
